import React from 'react';
import { createRoot } from 'react-dom/client';
import history from 'history/browser';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import PreviewProxy from 'components/PreviewProxy';
import PreviewExperience from 'components/PreviewExperience';
import App from 'components/App';
import { Root, initialize } from 'root';

if (import.meta.env.REACT_DEVTOOLS) {
  import('react-devtools');
}

// Root element to mount the builder
const $root = document.querySelector('#root');
const root = createRoot($root);

// eslint-disable-next-line unicorn/prefer-top-level-await
(async () => {
  // Short-circuit if preview proxy detected
  const { pathname, hash, search } = history.location;
  const searchHash = hash.replace('#', '');
  const params = Object.fromEntries(new URLSearchParams(search || searchHash));

  // If it's a route to the image-service
  // we render an specific page without authentication
  // to render only the experience preview
  if (pathname.includes('image-service') || hash.includes('image-service')) {
    root.render(<PreviewExperience />);
    return;
  }

  // If the url has type param
  // we should render the PreviewProxy which is a non-authenticated page
  if (params?.type || params?.democues) {
    root.render(<PreviewProxy params={params} />);
    return;
  }

  // Authenticate and get user initial data
  const { auth, user, account } = await initialize();

  // Initialize LaunchDarkly provider
  const LDProvider = await asyncWithLDProvider({
    clientSideID: import.meta.env.LAUNCHDARKLY_CLIENT_ID,
    context: {
      kind: 'user',
      key: auth.accountId,
      tier: account.tier,
      createdAt: account.createdAt,
    },
  });

  // Render application
  root.render(
    <LDProvider>
      <Root auth={auth} user={user}>
        <App />
      </Root>
    </LDProvider>
  );
})();
